module.exports = __webpack_public_path__ + "img/2_C.9e08919c.webp";